import { render, staticRenderFns } from "./SsrSelectionBox.vue?vue&type=template&id=619cbccc&scoped=true"
import script from "./SsrSelectionBox.vue?vue&type=script&lang=js"
export * from "./SsrSelectionBox.vue?vue&type=script&lang=js"
import style0 from "./SsrSelectionBox.vue?vue&type=style&index=0&id=619cbccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cbccc",
  null
  
)

export default component.exports